import React from 'react'
import PropTypes from 'prop-types'

import Box from '../Box'
import SectionHeader from './SectionHeader'

import styles from './styles.scss'

const NestedNavigation = (props) => {
  const { children } = props

  return (
    <Box backgroundColor="white" className={styles.root} flexDirection="column" height="100%" width="240px">
      {children}
    </Box>
  )
}

NestedNavigation.propTypes = {
  children: PropTypes.node.isRequired,
}


NestedNavigation.SectionHeader = SectionHeader

export default NestedNavigation
